var viewer_rtlignore_default = {
  "gallery_container": "IWO-N",
  "imageTitleContainer": "YUqse",
  "clickableItem": "S7jDg",
  "prerender": "pA5d-",
  "expandButton": "_6O8sT",
  "itemContainer": "twsW5",
  "expandIcon": "B3aFM",
  "itemOverlay": "Gy0O3",
  "imageTitle": "_0kihl",
  "pointer": "ZNhHr",
  "fadeIn": "zHzA8",
  "changing_background": "TJX2N"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
